import locale77dc9845 from '../../lang/pl.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"pl","numberFormats":{"pl":{"currency":{"style":"currency","currency":"PLN","currencyDisplay":"symbol"}},"en":{"currency":{"style":"currency","currency":"PLN","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"pl","file":"pl.js","iso":"pl_PL","defaultCurrency":"PLN","label":"PL"},{"code":"en","file":"en.js","iso":"en_US","defaultCurrency":"PLN","label":"EN"}],
  defaultLocale: "pl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "/usr/src/app/lang",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"pl","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "https://extracts.pro",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  country: "PL",
  normalizedLocales: [{"code":"pl","file":"pl.js","iso":"pl_PL","defaultCurrency":"PLN","label":"PL"},{"code":"en","file":"en.js","iso":"en_US","defaultCurrency":"PLN","label":"EN"}],
  localeCodes: ["pl","en"],
}

export const localeMessages = {
  'pl.js': () => Promise.resolve(locale77dc9845),
  'en.js': () => import('../../lang/en.js' /* webpackChunkName: "lang-en.js" */),
}
